import React from 'react';
import { Button } from 'semantic-ui-react';
import ReactFileReader from 'react-file-reader';

const UploadFile = ({
    field: { name, value},
    form: { touched, errors, setFieldValue },
    ...props
}) => {
    return (
        <>
            <ReactFileReader base64={true} fileTypes={props.typer}
                handleFiles={(value) => setFieldValue(name, value)}
                {...props}
            >
                <Button color={props.clrd} basic type='button' size='tiny' icon>
                    <i className="fas fa-upload"></i> {props.buttonName}
                </Button>
            </ReactFileReader>
        </>
    )
}

export default UploadFile